import { render, staticRenderFns } from "./user-sign.vue?vue&type=template&id=25c32e3a&scoped=true&"
import script from "./user-sign.vue?vue&type=script&lang=js&"
export * from "./user-sign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c32e3a",
  null
  
)

export default component.exports